// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Landing from "../../templates/Landing.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

var heroImg = {
  src: "https://images.instapainting.com/62567f67efbb5e323c8b456d.jpg?fit=crop&crop=focalpoint&fp-z=1.15",
  alt: "A mother holding her newborn baby on a plain background."
};

var pageTitle = "Custom Child Portrait Painting";

var metaDescription = "Turn your baby or kid photo into a personalized, handmade portrait. View thousands of examples from real customers. Ready to be shipped in about 7-10 days.";

var title = "Order a Personalized Oil Painting of";

var title2 = " Your Baby or Kid";

var description = "Turn your favorite photo into a 100% handmade physical painting from a master artist in oil, watercolor, charcoal, or other mediums. Select a product, upload a photo, and we'll find the best artist to paint \"child paintings\" shipped to your door in as little as 2 weeks.";

var secondaryContent = {
  title1: "Custom Child",
  title2: "Portrait Painting",
  body: "You can browse child painting samples from real customers and artists. Whether you prefer watercolor paintings, oil paintings, or pencil or charcoal drawings, our talented professional artists can do it all. Once you select the type of artwork you want, you can upload your child’s photo, add instructions for the artists, and submit your order. You’ll be pleasantly surprised at the fast turnaround, the easy and convenient review process, and the high-quality end result."
};

var mainCta = {
  text: "Upload a Photo",
  link: "/assets"
};

var altCta = {
  text: "Browse Baby & Children Gallery",
  link: "/gallery/baby-paintings"
};

var products = [
  {
    title: "Oil Painting",
    src: "https://images.instapainting.com/60d576b6522cfa74098b456a_w0.jpg?fp-z=1.55&fp-x=0.5&fp-y=0.5",
    imageAlt: "",
    sku: "custphotoreal",
    price: 89
  },
  {
    title: "Watercolor",
    src: "https://images.instapainting.com/61f362e3f1b8cd810e8b4576_w0.jpg?fp-z=1.2&fp-y=0.55",
    imageAlt: "",
    sku: "custwatercolor",
    price: 89
  },
  {
    title: "Charcoal",
    src: "https://images.instapainting.com/62318748eb69a2a76d8b456d.jpg?fp-z=1.15&fp-y=0.4&fp-x=0.55",
    imageAlt: "",
    sku: "custcharcoal",
    price: 89
  },
  {
    title: "Pencil Drawing",
    src: "https://images.instapainting.com/57e0a24787456f59568b456b.jpg?fp-z=1.0&fp-y=0.6",
    imageAlt: "",
    sku: "custpencil",
    price: 89
  },
  {
    title: "Colored-Pencil",
    src: "https://images.instapainting.com/6278da149f214cfdb18b4570.jpg?fp-z=1.0",
    imageAlt: "",
    sku: "custpencil",
    price: 89
  }
];

var reviews = [
  {
    name: "Jason L Caldwell",
    location: "McDonough, US",
    review: "I love it!! So may complimants on it too. I ordered more after getting this one back. Refered to my family also. Thanks!!",
    link: "/products/gallery/custphotoreal/5a06794687456ffd658b4585/?order=1",
    image: "https://images.instapainting.com/5a17814487456f61578b456b.jpg?fit=crop&crop=focalpoint&fp-y=.55&fp-z=2",
    imageAlt: "A child girl looking from behind a glass door",
    date: new Date("12/13/2017")
  },
  {
    name: "Stephanie Sousa",
    location: "Toronto, CA",
    review: "Absolutely in love with it. I'm speechless",
    link: "/products/gallery/custphotoreal/58f3f7dd87456ff01a8b4608/?order=1",
    image: "https://images.instapainting.com/58feaeb387456f2f2f8b457b.jpg",
    imageAlt: "An oil portrait of three child siblings, 2 boys and a girl.",
    date: new Date("04/25/2017")
  },
  {
    name: "Neury Trinidad",
    location: "Newark, US",
    review: "Great Job!",
    link: "/products/gallery/custphotoreal/581cad0687456f24278b4577/?order=1",
    image: "https://images.instapainting.com/5826a74387456fad448b4570.jpg",
    imageAlt: "An oil portrait of a girl toddler in a flower dress",
    date: new Date("11/12/2016")
  }
];

var contentBlocks = [
  {
    title1: "Hand-Painted Portrait of",
    title2: "Your Little One",
    body: "Having a baby is a life-changing event that will forever transform your family and your heart. Celebrate this new precious life with a child portrait painting created from one of your favorite photos. Our artists can transform a kid picture or baby picture to a painting using the highest quality materials and techniques that achieve the style and look you like.\n\nA hand-painted portrait of your little one is a great gift for yourself, your grandparents, your spouse, or for other close family members like aunts or uncles. Our experienced artists will take the necessary care and time to accurately capture the essence and personality of your child in a timeless portrait that’s sure to bring a smile to your face each and every time you look at it."
  },
  {
    title1: "Capture Your Cute Moments",
    title2: "on Canvas",
    body: "Ever wish you could capture an adorable moment with your child that you never want to forget, but a digital image just doesn’t seem to do it justice? Try transforming a kid picture to a painting with Instapainting! Our artists can take any image of your child and transform it into a beautiful, custom kid portrait painting that you and your family will absolutely adore.\n\nWith Instapainting, you can easily commission a talented artist and communicate directly with the artist of your choice. You’ll have opportunities to review the portrait as it’s being created and submit comments, requests, and revisions to ensure that you’re getting exactly what you want."
  },
  {
    title1: "Turn a Funny Photo of Your Children",
    title2: "Into a Cherished Memory",
    body: "A funny photo of your kid has the power to lift your mood, turn a bad day into a great one, or encourage and inspire you when you need it most. But what if you could take that photo and transform it into a beautiful work of art that you could hang in your home or office and enjoy all the time? Well, now you can!\n\nWith Instapainting, you can turn your favorite funny photo of your kid into a cherished memory that captures the unique and special personality of your little one. Whether you want to memorialize a special family trip, remember a loved one from the happiest of times, or give a priceless gift that will be adored and appreciated, our artists can create a custom kid picture to painting for you."
  },
  {
    title1: "",
    title2: "Start by Uploading Your Photos Today",
    body: "A personalized child portrait painting is truly a one-of-a-kind gift for any occasion and it’s one that will be cherished and valued instead of being tossed aside as it ages. If you’re searching for a new and creative way to enjoy special moments in time with your children, we can help.\n\nIf you’re ready to commission an artist to transform your kid’s picture into a custom painting, all you have to do is select the type of portrait you want and upload your photo. Once you’ve uploaded your picture, you can add any specific instructions for the artist and submit your order. We’ll be in touch shortly to help you choose an available artist that can provide the style and service you’re after. Generally, you’ll have your custom child or baby portrait in hand within three weeks’ time. What could be better than that!\n\nReady to get started? Upload your child’s photo today!"
  }
];

function BabyPaintingsPage(props) {
  return JsxRuntime.jsx(Landing.LandingPage.make, {
              pageTitle: pageTitle,
              heroImg: heroImg,
              title: title,
              title2: title2,
              description: description,
              metaDescription: metaDescription,
              secondaryContent: secondaryContent,
              mainCta: mainCta,
              altCta: altCta,
              products: products,
              reviews: reviews,
              contentBlocks: contentBlocks
            });
}

var make = BabyPaintingsPage;

var $$default = BabyPaintingsPage;

export {
  heroImg ,
  pageTitle ,
  metaDescription ,
  title ,
  title2 ,
  description ,
  secondaryContent ,
  mainCta ,
  altCta ,
  products ,
  reviews ,
  contentBlocks ,
  make ,
  $$default as default,
}
/*  Not a pure module */
